import {isTouchEnabled} from "./global/helpers"
import {kendoLoader} from "./kendo/loader";
import {kendoNotification} from "./kendo/notification";
import {kendoMenu as kendoMenuInit} from "./kendo/menu";
import {handleComponents} from "./global/components";
import {handleWindowHistory} from "./global/components/windowHistory";
import {handleKendoBlueImpGallery} from "./global/components/kendoImgGallery";
import {handleModalAnchors} from "./global/components/modalAnchors";
import {initGlobalProductSearch} from "./global/components/globalProductSearch";
import {initGlobalOrderSearch} from "./global/components/globalOrderSearch";
import {initK1ActionHref} from "./global/components/ajaxHandlers";
import {initK1Confirms} from "./global/components/confirm";
import {initK1Submit} from "./global/components/submit";
import {registerKendoToolbarOptionList} from "./kendo/toolbarOptionList";
import naja from "./modules/naja";
import {menuBuilder} from "./functions/menuBuilder";
import {gridFormSubmit} from "./global/forms/gridForm";
import {loadDetailContent} from "./grid/detail";
import {copyHref} from "./functions/copyHref";

// htmx
import htmx from 'htmx.org';

window.htmx = htmx;

let detailContentLoaderCallback = []
let specialModalContentLoaderCallback = []
let defaultModalContentLoaderCallback = []
let fullscreenModalContentLoaderCallback = []
let staticNotification = null

window.TracyMaxAjaxRows = 3;
window.detailContentLoaderCallback = detailContentLoaderCallback
window.specialModalContentLoaderCallback = specialModalContentLoaderCallback
window.defaultModalContentLoaderCallback = defaultModalContentLoaderCallback
window.fullscreenModalContentLoaderCallback = fullscreenModalContentLoaderCallback
window.staticNotification = staticNotification
window.loadDetailContent = loadDetailContent
window.menuBuilder = menuBuilder
window.copyHref = copyHref
window.handleKendoBlueImpGallery = handleKendoBlueImpGallery;

// Kendo sets aria-hidden="true" on animation containers before removing focus from inner elements.
// Blur focused descendants proactively to suppress the browser aria-hidden accessibility warning.
new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		if (mutation.target.getAttribute('aria-hidden') !== 'true') {
			return;
		}
		const focused = mutation.target.querySelector(':focus');
		if (focused) {
			focused.blur();
		}
	});
}).observe(document.body, {subtree: true, attributes: true, attributeFilter: ['aria-hidden']});

$(document).ready(function () {
	naja.init();

	window.k1Loader = kendoLoader();
	window.staticNotification = kendoNotification();
	kendoMenuInit();
	registerKendoToolbarOptionList();

	$('.beforeInit').removeClass('beforeInit');
	$('[kendo-menu] > li > ul').css('visibility', 'visible').css('height', 'auto');

	handleComponents('body');

	if (isTouchEnabled()) {
		$('[kendo-menu] > li > ul > li > a').removeAttr('href');
	}

	handleWindowHistory();

	handleKendoBlueImpGallery();
	handleModalAnchors();

	$("#application-menu ul:not(:has(li))").closest('li').detach();
	$("#application-menu ul:not(:has(li))").closest('li').detach();

	initGlobalProductSearch();
	initGlobalOrderSearch();
	gridFormSubmit();

	initK1ActionHref();
	initK1Confirms();
	initK1Submit();
});
